import { AppContentWrapperStyles } from 'components/app-content-wrapper/app-content-wrapper.styles';
import { CustomFonts } from 'components/custom-fonts';
import React from 'react';

import { useGetTheme } from 'hooks/use-get-theme.hook';
import { useBrandCssVariables } from 'hooks/use-brand-css-variables.hook';
import { useSelector } from 'react-redux';
import { selectBrandTheme } from 'store/theme/selectors';
import { HqoTheme, HqoThemeProvider } from '@hqo/react-components-library/dist/hqo-theme-provider';

interface AppContentWrapperProps {
  children: React.ReactNode;
}

export const AppContentWrapper = ({ children }: AppContentWrapperProps): JSX.Element => {
  const theme = useGetTheme();
  const brandTheme = useSelector(selectBrandTheme);
  // Same precedence as useGetTheme: primary1 overrides primary_color. The font colour is the
  // brand's own, not a derived one -- tenant-portal pairs those same two fields.
  useBrandCssVariables(brandTheme?.primary1 || brandTheme?.primary_color, brandTheme?.primary_font_color);

  return (
    <>
      {/* @ts-ignore */}
      <AppContentWrapperStyles customThemeFonts={theme.fonts} />
      <CustomFonts />
      <HqoThemeProvider theme={theme as HqoTheme}>{children}</HqoThemeProvider>
    </>
  );
};
